import React from 'react';
import { useAppSelector } from '../../../../../../store/hooks';
import { orderAttachmentsFiltersSelector } from '../../../../../../store/selectors/ordersSelector';
import { setOrdersAttachmentsFilter } from '../../../../../../store/slices/ordersSlice';
import { AttachmentsColumnsProps } from '../../../../../../core/types/coreTypes';
import AttachmentColumns from '../../../../../../common/components/attachments-table/AttachmentColumns';
import usePermission from '../../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import { useCoreAttachmentsColumns } from '../../../../../../core/hooks/useCoreAttachmentsColumns';

const OrderAttachmentColumns:React.FC<AttachmentsColumnsProps> = ({
  isAll, checkAll, totalElements, indeterminate,
}) => {
  const attachmentsFilters = useAppSelector(orderAttachmentsFiltersSelector);
  const allowedManage = usePermission(PermissionEnum.OrderEditFields);

  const {
    searchVl,
    pickerValue,
    setPickerValue,
    sortHandle,
    onChangeSearchHandle,
    searchPressHandle,
    pickerHandle,
  } = useCoreAttachmentsColumns(attachmentsFilters, setOrdersAttachmentsFilter);

  return (
    <AttachmentColumns
      allowedManage={!!allowedManage}
      isAll={isAll}
      indeterminate={indeterminate}
      checkAll={checkAll}
      sortHandle={sortHandle}
      onChangeSearchHandle={onChangeSearchHandle}
      searchPressHandle={searchPressHandle}
      totalElements={totalElements}
      searchVl={searchVl}
      pickerValue={pickerValue}
      setPickerValue={setPickerValue}
      pickerHandle={pickerHandle}
      tableFilters={attachmentsFilters}
      isManageAttachmentsVisibilityInJobs
    />
  );
};

export default OrderAttachmentColumns;
